'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _equivalent = require('./equivalent');

var _equivalent2 = _interopRequireDefault(_equivalent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debounce = function debounce(func) {
	var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

	var promise = void 0;
	var lastArgs = void 0;
	var later = void 0;
	var timeout = void 0;
	return function () {
		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		if (promise) {
			if ((0, _equivalent2.default)(args, lastArgs)) {
				return promise;
			}
			promise.reject();
			promise = null;
		}
		clearTimeout(timeout);
		lastArgs = args;
		if (!promise) {
			var rejectCallback = void 0;
			promise = new _promise2.default(function (resolve, reject) {
				rejectCallback = reject;
				later = function later() {
					resolve(func.apply(undefined, lastArgs));
					promise = null;
				};
			});
			promise.reject = rejectCallback;
		}
		timeout = setTimeout(later, duration);
		return promise;
	};
};

var _default = debounce;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(debounce, 'debounce', 'src/utilities/debounce.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/utilities/debounce.js');
}();

;


// WEBPACK FOOTER //
// /Users/david/Source/react-formality/lib/utilities/debounce.js